export * from "./loading-page";
export * from "./loading-container.component";



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/spinner/index.ts